(function () {
  function norm(s) {
    return String(s || '')
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '');
  }

  function cap(s) {
    return String(s || '').replace(/(^\w|\s\w|'|\-\w)/g, function (m) {
      return m.toUpperCase();
    });
  }

  function loadCities() {
    var el = document.getElementById('fg-cities-data');
    if (!el || !el.textContent) return [];
    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed.map(function (c) { return String(c).trim().toUpperCase(); }).filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function bindCep(coveredSet, strings) {
    var wrap = document.querySelector('[data-fg-cep]');
    if (!wrap) return;
    var inp = wrap.querySelector('[data-fg-cep-input]');
    var btn = wrap.querySelector('[data-fg-cep-btn]');
    var res = wrap.querySelector('[data-fg-cep-res]');
    if (!inp || !res) return;

    inp.addEventListener('input', function () {
      var v = inp.value.replace(/\D/g, '');
      if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5, 8);
      inp.value = v;
    });

    function checkCep() {
      var raw = inp.value.replace(/\D/g, '');
      if (raw.length !== 8) {
        res.className = 'cep-res err';
        res.textContent = strings.invalidCep;
        return;
      }
      res.className = 'cep-res loading';
      res.textContent = strings.loading;
      fetch('https://viacep.com.br/ws/' + raw + '/json/')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.erro) {
            res.className = 'cep-res err';
            res.textContent = strings.cepNotFound;
            return;
          }
          var city = norm((d.localidade || '').toUpperCase());
          var ok = false;
          coveredSet.forEach(function (c) {
            if (norm(c) === city) ok = true;
          });
          if (ok) {
            res.className = 'cep-res ok';
            res.textContent = strings.okPrefix + d.localidade + strings.okSuffix;
          } else {
            res.className = 'cep-res err';
            res.textContent = strings.failPrefix + d.localidade + strings.failSuffix;
          }
        })
        .catch(function () {
          res.className = 'cep-res err';
          res.textContent = strings.networkError;
        });
    }

    if (btn) btn.addEventListener('click', checkCep);
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') checkCep();
    });
  }

  function bindCities(allCities, strings) {
    var wrap = document.querySelector('[data-fg-cities]');
    if (!wrap) return;
    var search = wrap.querySelector('[data-fg-city-search]');
    var grid = wrap.querySelector('[data-fg-city-grid]');
    var meta = wrap.querySelector('[data-fg-city-meta]');
    var moreBtn = wrap.querySelector('[data-fg-more-btn]');
    if (!grid || !meta) return;

    var sorted = allCities.slice().sort();
    var INIT = parseInt(wrap.getAttribute('data-initial-show') || '30', 10) || 30;
    if(window.innerWidth < 600) {
      INIT = 8;
    }
    var showing = INIT;
    var current = sorted;

    function render(list) {
      grid.innerHTML = '';
      list.forEach(function (c, i) {
        var div = document.createElement('div');
        div.className = 'city' + (i >= showing ? ' hide' : '');
        div.textContent = cap(c.toLowerCase());
        grid.appendChild(div);
      });
      meta.textContent = strings.meta
        .replace('[n]', String(Math.min(showing, list.length)))
        .replace('[total]', String(list.length));
      if (moreBtn) {
        moreBtn.style.display = list.length > showing ? 'block' : 'none';
      }
    }

    function filterCities() {
      if (!search) return;
      var q = norm(search.value.trim().toUpperCase());
      showing = INIT;
      current = sorted.filter(function (c) {
        return norm(c).includes(q);
      });
      render(current);
    }

    function showAll() {
      showing = current.length;
      render(current);
    }

    if (search) search.addEventListener('input', filterCities);
    if (moreBtn) moreBtn.addEventListener('click', showAll);

    render(sorted);
  }

  function readStrings(el) {
    if (!el) {
      return {
        invalidCep: 'Por favor insira um CEP válido com 8 dígitos.',
        loading: 'Consultando…',
        cepNotFound: 'CEP não encontrado. Verifique e tente novamente.',
        okPrefix: '✓ ',
        okSuffix: ' tem Frete Grátis na compra de 2+ pares!',
        failPrefix: '✗ ',
        failSuffix: ' ainda não está na lista de cidades cobertas.',
        networkError: 'Erro ao consultar. Verifique sua conexão.',
        meta: '[n] de [total] cidades exibidas',
      };
    }
    return {
      invalidCep: el.getAttribute('data-invalid-cep') || '',
      loading: el.getAttribute('data-loading') || '',
      cepNotFound: el.getAttribute('data-cep-not-found') || '',
      okPrefix: el.getAttribute('data-ok-prefix') || '',
      okSuffix: el.getAttribute('data-ok-suffix') || '',
      failPrefix: el.getAttribute('data-fail-prefix') || '',
      failSuffix: el.getAttribute('data-fail-suffix') || '',
      networkError: el.getAttribute('data-network-error') || '',
      meta: el.getAttribute('data-meta-template') || '[n] de [total] cidades exibidas',
    };
  }

  function bindReveal() {
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) e.target.classList.add('show');
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.fg-page .rv').forEach(function (el) {
      obs.observe(el);
    });
  }

  function init() {
    if (window.FRETE_GRATIS_PAGE_INIT) return;
    window.FRETE_GRATIS_PAGE_INIT = true;
    var cities = loadCities();
    var coveredSet = new Set(cities);
    var strEl = document.querySelector('[data-fg-strings]');
    var strings = readStrings(strEl);
    var unique = [];
    cities.forEach(function (c) {
      if (unique.indexOf(c) === -1) unique.push(c);
    });
    bindCep(coveredSet, strings);
    bindCities(unique, strings);
    bindReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
